"use client";
import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import Image from "next/image";

export default function Testimonials() {
	return (
		<section id={"testimonials"}>
			<div className="container">
				<div className="section-title lg:space-y-7.5 mb-10 space-y-5 text-center sm:mb-14">
					<span>Testimonials</span>
					<h2 className="font-bold">Why Our Clients Love Us</h2>
					<p className="font-Poppins mx-auto max-w-[580px] -tracking-[0.36px] lg:max-w-2xl xl:max-w-[730px]">
						Our customers stick with us in business for multiple years
					</p>
				</div>
			</div>
			<div className="overflow-hidden px-4 sm:px-0">
				<Swiper
					modules={[Pagination, Autoplay]}
					pagination={{ el: ".swiper-pagination", clickable: true }}
					slidesPerView="auto"
					centeredSlides={true}
					loop={false}
					speed={1000}
					autoHeight={true}
					autoplay={{ delay: 3500 }}
					breakpoints={{
						0: { slidesPerView: 1, spaceBetween: 20 },
						640: { slidesPerView: "auto", spaceBetween: 0 },
						768: {},
						1200: {},
					}}
					className="testimonial-slider"
				>
					<div className=" pb-14">
						<SwiperSlide className="swiper-slide relative sm:!w-[600px] lg:!w-[750px] xl:!w-[918px]">
							<div className=" flex flex-col-reverse rounded-[21px] border border-[#DDE8F0] bg-[#F7F9FF] before:absolute before:left-0 before:top-0 before:h-[388px] before:w-[394px] before:rounded-[21px] before:bg-[linear-gradient(312deg,_rgba(0,94,255,0.00)_57%,_rgba(0,94,255,0.20)_98.74%)] sm:flex-row ">
								<div className="z-10 shrink-0 border-r-[#DDE8F0] px-4 pb-5 pt-0 sm:border-r sm:pb-10 sm:pt-8 lg:pb-12 lg:pl-6 lg:pr-5 lg:pt-10 xl:pb-16 xl:pl-10 xl:pr-7 xl:pt-[52px]">
									<h3 className="text-title after:bg-primary-500 relative mb-8 w-[188px] pb-6 text-xl font-bold after:absolute after:bottom-0 after:left-0 after:h-[5px] after:w-[87px] after:rounded-xl sm:mb-16 lg:mb-24 lg:w-[220px] lg:text-2xl xl:w-[265px] xl:text-3xl">
										Please consider introducing yourself in the VIP room.
									</h3>
									<a href="#bookADiscoveryCall" className="theme-btn text-sm lg:min-w-[250px]">
										Book a Free Discovery Call
									</a>
								</div>
								<div className="relative z-10 p-5 lg:p-8 xl:p-12">
									<div className="flex items-center justify-between">
										<div className="flex items-center gap-3">
											<Image
												src="/marketing/assets/img/testimonial/client-img-1.png"
												alt="Chandra Sekhar Babu Vasireddy - Incircles Arena CEO"
												className="w-11 rounded-full lg:w-[60px]"
												width={120}
												height={120}
											/>
											<div>
												<h4 className="text-title text-base leading-[120%] lg:text-xl xl:text-2xl">
													Chandra Sekhar Babu Vasireddy
												</h4>
												<span className="text-sm italic leading-normal text-[#5C7080] lg:text-lg xl:text-xl">
													CEO, Incircles Arena
												</span>
											</div>
										</div>
										<Image
											src="/marketing/assets/img/testimonial/testimonial-logo-1.svg"
											alt="Incircles Arena Testimonial"
											width={106}
											height={57}
										/>
									</div>
									<div className="mt-8 space-y-5 sm:mt-12 lg:mt-[60px] lg:space-y-7">
										<p className="font-Poppins text-sm capitalize -tracking-[0.36px] text-[#000D49B2] lg:text-base xl:text-lg">
											&quot;We were about to launch our new platform in the US Market. While we were
											looking for marketing partners, we chanced upon Proptechbuzz.
										</p>
										<p className="font-Poppins text-sm capitalize -tracking-[0.36px] text-[#000D49B2] lg:text-base xl:text-lg">
											Partnering with them helped us accelerate our product&apos;s brand awareness
											and growth engines.&quot;
										</p>
									</div>
								</div>
							</div>
						</SwiperSlide>
						<SwiperSlide className="swiper-slide relative sm:!w-[600px] lg:!w-[750px] xl:!w-[918px]">
							<div className=" flex flex-col-reverse rounded-[21px] border border-[#DDE8F0] bg-[#F7F9FF] before:absolute before:left-0 before:top-0 before:h-[388px] before:w-[394px] before:rounded-[21px] before:bg-[linear-gradient(312deg,_rgba(0,94,255,0.00)_57%,_rgba(0,94,255,0.20)_98.74%)] sm:flex-row ">
								<div className="z-10 shrink-0 border-r-[#DDE8F0] px-4 pb-5 pt-0 sm:border-r sm:pb-10 sm:pt-8 lg:pb-12 lg:pl-6 lg:pr-5 lg:pt-10 xl:pb-16 xl:pl-10 xl:pr-7 xl:pt-[52px]">
									<h3 className="text-title after:bg-primary-500 relative mb-8 w-[188px] pb-6 text-xl font-bold after:absolute after:bottom-0 after:left-0 after:h-[5px] after:w-[87px] after:rounded-xl sm:mb-16 lg:mb-24 lg:w-[220px] lg:text-2xl xl:w-[265px] xl:text-3xl">
										Please consider introducing yourself in the VIP room.
									</h3>
									<a href="#bookADiscoveryCall" className="theme-btn text-sm lg:min-w-[250px]">
										Book a Free Discovery Call
									</a>
								</div>
								<div className="relative z-10 p-5 lg:p-8 xl:p-12">
									<div className="flex justify-between">
										<div className="flex items-center gap-3">
											<Image
												src="/marketing/assets/img/testimonial/client-img-2.png"
												alt="client img"
												className="w-11 rounded-full lg:w-[60px]"
											/>
											<div>
												<h4 className="text-title text-base leading-[120%] lg:text-xl xl:text-2xl">
													James Beckmann
												</h4>
												<span className="text-sm italic leading-normal text-[#5C7080] lg:text-lg xl:text-xl">
													CEO, Ask The Agent
												</span>
											</div>
										</div>
										<Image
											src="/marketing/assets/img/testimonial/testimonial-logo-2.svg"
											alt="testimonial logo"
											className="w-20 lg:w-28 xl:w-[135px]"
										/>
									</div>
									<div className="mt-8 space-y-5 sm:mt-12 lg:mt-[60px] lg:space-y-7">
										<p className="font-Poppins text-sm capitalize -tracking-[0.36px] text-[#000D49B2] lg:text-base xl:text-lg">
											&quot;We were looking for a partner to help us accelerate our growth marketing
											initiatives and also help us with our brand awareness.
										</p>
										<p className="font-Poppins text-sm capitalize -tracking-[0.36px] text-[#000D49B2] lg:text-base xl:text-lg">
											Partnering with them helped us accelerate our product&apos;s brand awareness
											and growth engines.&quot;
										</p>
									</div>
								</div>
							</div>
						</SwiperSlide>
						<SwiperSlide className="sm:!w-[600px] lg:!w-[750px] xl:!w-[918px]">
							<div className=" flex flex-row rounded-[21px] border border-[#DDE8F0] bg-[#F7F9FF] before:absolute before:left-0 before:top-0 before:h-[388px] before:w-[394px] before:rounded-[21px] before:bg-[linear-gradient(312deg,_rgba(0,94,255,0.00)_57%,_rgba(0,94,255,0.20)_98.74%)] sm:flex-row ">
								<div className="z-10 shrink-0 border-r-[#DDE8F0] px-4 pb-5 pt-0 sm:border-r sm:pb-10 sm:pt-8 lg:pb-12 lg:pl-6 lg:pr-5 lg:pt-10 xl:pb-16 xl:pl-10 xl:pr-7 xl:pt-[52px]">
									<h3 className="text-title after:bg-primary-500 relative mb-8 w-[188px] pb-6 text-xl font-bold after:absolute after:bottom-0 after:left-0 after:h-[5px] after:w-[87px] after:rounded-xl sm:mb-16 lg:mb-24 lg:w-[220px] lg:text-2xl xl:w-[265px] xl:text-3xl">
										Please consider introducing yourself in the VIP room.
									</h3>
									<a href="#bookADiscoveryCall" className="theme-btn text-sm lg:min-w-[250px]">
										Book a Free Discovery Call
									</a>
								</div>
								<div className="relative z-10 p-5 lg:p-8 xl:p-12">
									<div className="flex justify-between">
										<div className="flex items-center gap-3">
											<Image
												src="/marketing/assets/img/testimonial/client-img-2.png"
												alt="client img"
												className="w-11 rounded-full lg:w-[60px]"
											/>
											<div>
												<h4 className="text-title text-base leading-[120%] lg:text-xl xl:text-2xl">
													James Beckmann
												</h4>
												<span className="text-sm italic leading-normal text-[#5C7080] lg:text-lg xl:text-xl">
													CEO, Ask The Agent
												</span>
											</div>
										</div>
										<Image
											src="/marketing/assets/img/testimonial/testimonial-logo-2.svg"
											alt="testimonial logo"
											className="w-20 lg:w-28 xl:w-[135px]"
										/>
									</div>
									<div className="mt-8 space-y-5 sm:mt-12 lg:mt-[60px] lg:space-y-7">
										<p className="font-Poppins text-sm capitalize -tracking-[0.36px] text-[#000D49B2] lg:text-base xl:text-lg">
											&quot;We were looking for a partner to help us accelerate our growth marketing
											initiatives and also help us with our brand awareness.
										</p>
										<p className="font-Poppins text-sm capitalize -tracking-[0.36px] text-[#000D49B2] lg:text-base xl:text-lg">
											Proptechbuzz helped us massively in our outreach campaign to over 300K real
											estate agents and&quot;
										</p>
									</div>
								</div>
							</div>
						</SwiperSlide>
					</div>
					<div className="swiper-pagination !bottom-0 !top-auto" />
				</Swiper>
			</div>
		</section>
	);
}
